import React, { useState } from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "../../assets/images/more_vert.svg";
import DisMoreVertIcon from "../../assets/images/dis_more_vert.svg";

interface DropdownProps {
	menuItems: Record<string, any>[];
	onSelect: (item:any)=> void;
	edit: boolean
}

const DropdownMenu:React.FC<DropdownProps> = ({ menuItems = [], onSelect, edit = false }) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		const selectedValue = event.currentTarget;
		setAnchorEl(selectedValue);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuItemClick = (item:any) => {
		handleClose();
		if (onSelect) {
			onSelect(item);
		}
	};

	return (
		<>
			<IconButton
				aria-label="menu"
				aria-controls="dropdown-menu"
				aria-haspopup="true"
				onClick={handleClick}
				disabled={edit}
			>
            {edit ?  (
            <img src={DisMoreVertIcon} alt="Less" />
           )   : (
          <img src={MoreVertIcon} alt="More" />
           )}
			</IconButton>
			<Menu
				id="dropdown-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				{menuItems.map((item, index) => (
					<MenuItem
						key={index}
						disabled={item.disabled}
						onClick={() => {
							if (!item.disabled) {
							handleMenuItemClick(item);
							}
						}}
						sx={{
							cursor: item.disabled ? 'not-allowed' : 'pointer',
							color: item.disabled ? 'gray' : 'inherit',
						}}
					>
						{item.label}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default DropdownMenu;
